import React from 'react';
import Modal from '../../common/Modal';
import Button from '../../common/Button';

const ViewContractModal = ({ isOpen, onClose, contract }) => {
  if (!contract) return null;

  const footer = (
    <Button variant="secondary" onClick={onClose}>
      Close Details
    </Button>
  );

  const SectionTitle = ({ children }) => (
    <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
      {children}
    </h4>
  );

  const DetailRow = ({ label, value }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '16px' }}>
      <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontWeight: '500' }}>{label}</span>
      <span style={{ fontSize: '15px', color: 'var(--text-primary)', fontWeight: '600' }}>{value || 'N/A'}</span>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Contract Details - ${contract.po_number || contract.contract_id}`} size="medium" footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        
        {/* General Details */}
        <div style={{ padding: '16px', background: 'var(--surface-light)', borderRadius: '8px' }}>
          <SectionTitle>General Information</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <DetailRow label="PO Number" value={contract.po_number || contract.contract_id} />
            <DetailRow label="Status" value={contract.is_enabled ? 'Active' : 'Disabled'} />
            <DetailRow label="Contract Type" value={contract.type} />
            <DetailRow label="Contract Value" value={`₹${Number(contract.value).toLocaleString()}`} />
          </div>
        </div>

        {/* Allocation */}
        <div style={{ padding: '16px', border: '1px solid var(--border)', borderRadius: '8px' }}>
          <SectionTitle>Allocation</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <DetailRow label="Company" value={contract.company?.company_name || contract.company_name} />
            <DetailRow label="Site Name" value={contract.site?.name || contract.site_name} />
            <DetailRow label="Site Location" value={contract.site?.location || contract.location} />
          </div>
        </div>

        {/* Timeline */}
        <div style={{ padding: '16px', border: '1px solid var(--border)', borderRadius: '8px' }}>
          <SectionTitle>Timeline</SectionTitle>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <DetailRow label="Start Date" value={contract.start_date} />
            <DetailRow label="End Date" value={contract.end_date} />
          </div>
        </div>

        {/* Services */}
        <div style={{ padding: '16px', background: 'var(--surface-light)', borderRadius: '8px' }}>
          <SectionTitle>Services Covered</SectionTitle>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            {/* Comprehensive Section */}
            <div>
              <h5 style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></span>
                Comprehensive
              </h5>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {contract.services?.comprehensive?.length > 0 ? (
                  contract.services.comprehensive.map((service, index) => (
                    <span key={index} style={{
                      padding: '4px 10px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.2)', borderRadius: '16px', fontSize: '12px', fontWeight: '500', color: '#059669'
                    }}>
                      {service}
                    </span>
                  ))
                ) : (
                  <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontStyle: 'italic' }}>None</span>
                )}
              </div>
            </div>

            {/* Non-Comprehensive Section */}
            <div>
              <h5 style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#f59e0b' }}></span>
                Non-Comprehensive
              </h5>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {contract.services?.non_comprehensive?.length > 0 ? (
                  contract.services.non_comprehensive.map((service, index) => (
                    <span key={index} style={{
                      padding: '4px 10px', background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.2)', borderRadius: '16px', fontSize: '12px', fontWeight: '500', color: '#d97706'
                    }}>
                      {service}
                    </span>
                  ))
                ) : (
                  <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontStyle: 'italic' }}>None</span>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default ViewContractModal;